import saveUploadingFilesToState from '../actions/saveUploadingFilesToState'

export default [saveUploadingFilesToState]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/saveUploadingFilesToState.js